document.addEventListener("DOMContentLoaded", function() {
    const aa = require("search-insights");

    aa('init', {
        appId: process.env.MIX_ALGOLIA_APPLICATION_ID,
        apiKey: process.env.MIX_ALGOLIA_SEARCH_API_KEY,
        useCookie: true
    });

    aa('viewedFilters', {
        userToken: document.cookie.split('; ').find(row => row.startsWith('_ALGOLIA')).split('=')[1],
        index: process.env.MIX_ALGOLIA_ENTRIES_INDEX,
        eventName: 'Filtered Page Viewed',
        filters: document.querySelector('meta[name="algoliaFilters"]').content.split(','),
    });
});